import(/* webpackMode: "eager" */ "/home/runner/work/product-frontend/product-frontend/app/[locale]/(public)/auth/login/page.tsx");
